import React, { useState } from "react";
const playIcon = require("./styles/play.svg");
import _ from "lodash";
import millisecondsTohms from "../../utils/millisecondsTohms";

interface VideoThumbnailProps {
  thumbnail?: string | null;
  videoDuration?: number | null;
  downloadURL?: string;
  id: string | number;
  handleDownloadSelector?: Function;
  selectedMedia?: Array<string>;
}

const VideoThumbnail = ({ thumbnail, videoDuration }: VideoThumbnailProps) => {
  return (
    <div className="video-card">
      {thumbnail ? (
        <>
          {videoDuration != null ? (
            <span className="time-stamp">{millisecondsTohms(videoDuration)}</span>
          ) : null}
          <img className="play-icon" src={playIcon} />
          <img className="video-img" src={thumbnail} alt="" />
        </>
      ) : (
        <div className="ws-empty-img">
          <span className="loading-spinner">
            <span className="fa fa-spinner fa-spin"></span>
          </span>
        </div>
      )}
    </div>
  );
};

export default VideoThumbnail;
